import { render } from "./InvoiceHeader.vue?vue&type=template&id=65d62152"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__